<template>
  <header class="app-header d-flex justify-end align-center">
    <ShareChatButton />
    <v-menu
      v-model="menuOpen"
      location="bottom"
      content-class="user-dropdown"
      width="150"
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          variant="text"
          class="user-btn"
          rounded
          height="36"
          elevation="0"
          :ripple="false"
        >
          <v-icon
            size="20"
            class="me-2"
            color="primary"
          >
            mdi-account-circle
          </v-icon>
          <span class="user-name">{{ userName || 'Guest' }}</span>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-if="isAuthenticated"
          @click="logout"
        >
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-else
          @click="login"
        >
          <v-list-item-title>Login</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </header>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { ServiceLocator } from '@/services/ServiceLocator';
  import ShareChatButton from '@/interfaces/components/ShareChatButton.vue';
  import { authState } from '@/interfaces/composables/auth/authState';

  const userName = authState.userName;
  const guestUser = 'Guest';
  const menuOpen = ref(false);
  const showLoginModal = authState.showLoginPopup;

  const isAuthenticated = computed(
    () => userName.value && userName.value !== 'Guest'
  );

  // --- Helper: Reset state to guest ---
  function setGuestState() {
    userName.value = guestUser;
    authState.isAuthenticated.value = false;
    showLoginModal.value = true;
  }

  function login() {
    authState.mode.value = 'login';
    authState.showLoginPopup.value = true;
  }

  function logout() {
    const authService = ServiceLocator.getAuthService();
    authService.logout();
    setGuestState();
  }
</script>

<style scoped lang="sass">
  .app-header
    position: absolute
    top: 0
    right: 0
    left: 0
    height: 54px
    z-index: 10
    background: transparent
    pointer-events: none // lets content below still be clickable

  .user-btn
    pointer-events: auto
    margin-right: 1rem
    margin-top: 0.5rem
    text-transform: none
    font-size: 0.9rem
    font-weight: 500
    color: #333
    background-color: #f5f7fa
    border-radius: 8px
    padding: 0 12px
    transition: background-color 0.2s ease

    &:hover
      background-color: #e3f2fd

  .user-name
    padding-right: 4px

  .user-dropdown
    border-radius: 10px
    background-color: #fff
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08)
    padding: 6px 0
    min-width: 180px
    cursor: default

  .v-list-item
    margin: 4px 8px
    border-radius: 8px
    padding: 8px 12px
    transition: background-color 0.2s ease

    &:hover
      background-color: #e3f2fd
      cursor: pointer

  .v-list-item-title
    font-size: 0.95rem
    font-weight: 500
    color: #333
</style>
